module.exports = __webpack_public_path__ + "static/test-management-office@2x-ec04d077242191005e9d175a6288217b.jpg";